module.exports = __webpack_public_path__ + "img/1_2-parco-2-bosco.627d7a9b.png";